import React from 'react';
import AdminDashboardContent from '../Components/Dashboard/AdminDashboardContent';
import UserDashboardContent from '../Components/Dashboard/UserDashboardContent';
import LoginLayout from '../Layouts/LoginLayout';

export default function Dashboard() {
  return (
    <LoginLayout>
      {
        localStorage.getItem('isAdmin') == 0 ? <UserDashboardContent /> : <AdminDashboardContent />
      }
    </LoginLayout>
  )
}
